import "./index.css";
import Button from "../button";
import { useState } from "react";
import { submitNewUrl } from "../../functions/submitUrl";

function InputModule({ display, functionForButton }) {
  const [stage, setStage] = useState(0);
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [url, setUrl] = useState("");

  const handleClose = () => {
    setUrl("");
    setStage(0);
    setIsError(false);
    setErrorMessage("");
    functionForButton();
  };

  const handleSubmit = async () => {
    const response = await submitNewUrl(url, setIsError, setErrorMessage);
    if (response === true) {
      setStage(1);
    }
  };

  return (
    <div id="blur-wrapper" style={{ display }}>
      <div id="add-module">

        <div id="im-header">
          <div>
            <p className="im-eyebrow">Feed Sources</p>
            <h2 className="im-title highlight-green">
              {stage === 0 ? "Add a site" : "Site added"}
            </h2>
          </div>
          <button className="im-close-btn" onClick={handleClose} aria-label="Close">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M1 1l14 14M15 1L1 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </button>
        </div>

        {stage === 0 && (
          <div id="im-body">
            <p className="im-hint">Enter the root domain of a website you want to crawl for new content. We'll alert you the moment new posts appear.</p>
            <div className="im-field">
              <label className="im-label">Domain</label>
              <input
                id="url-input-field"
                className="im-text-input"
                type="url"
                placeholder="https://example.com"
                value={url}
                onChange={(e) => setUrl(e.target.value)}
              />
            </div>
            {isError && (
              <div id="input-error-module" dangerouslySetInnerHTML={{ __html: errorMessage }} />
            )}
            <Button text="Add site" addedFunction={handleSubmit} />
          </div>
        )}

        {stage === 1 && (
          <div id="im-confirmation">
            <svg width="44" height="44" viewBox="0 0 44 44" fill="none">
              <circle cx="22" cy="22" r="21" stroke="#0AFB60" strokeWidth="1.5" opacity="0.35" />
              <path d="M13 22l7 7 11-14" stroke="#0AFB60" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <p className="im-confirm-title">You're all set</p>
            <p className="im-confirm-sub">We'll crawl this site and email you as soon as we find new content for your feed.</p>
            <Button text="View my sites" addedFunction={() => { window.location.href = '/sites'; }} />
          </div>
        )}

      </div>
    </div>
  );
}

export default InputModule;
